import {useQuery, useQueryClient} from 'react-query'
import {OnlineToolsEditModalForm} from './OnlineToolsEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'

const OnlineToolsEditModalFormWrapper = () => {
  const { query } = useQueryResponse()
  const queryClient = useQueryClient()
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)

  // const {
  //   isLoading,
  //   data: onlineTools,
  //   error,
  // } = useQuery(
  //   `${QUERIES.PARAMETER_LIST}-parameter-${itemIdForUpdate}`,
  //   () => {
  //     return getParameterById(itemIdForUpdate)
  //   },
  //   {
  //     cacheTime: 0,
  //     enabled: enabledQuery,
  //     onError: (err) => {
  //       setItemIdForUpdate(undefined)
  //       console.error(err)
  //     },
  //   }
  // )


  if (!itemIdForUpdate) {
    return <OnlineToolsEditModalForm  onlineTools = {{ id: undefined}} />
  }

  return null
}

export {OnlineToolsEditModalFormWrapper}
